import { requester } from "App";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { decode } from "shared/utils/Utils";
import puffuIcon from "resources/img/puffu/puffuIcon.png";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import Container from "layouts/container/Container";
import Dummy from "components/Dummy";


function PaymentComplete() {
    const [testState, setTestState] = useState("");
    const [visible, setVisible] = useState(true);
    const onClick = () => {
        const userAgent = navigator.userAgent.toLowerCase();

        // 웹뷰 감지 로직 강화
        const isWebView = (() => {
            const isIOSWebView = /(iphone|ipod|ipad).*applewebkit(?!.*safari)/i.test(userAgent);
            const isAndroidWebView = /wv/.test(userAgent) || /android.*samsungbrowser\/(?!.*chrome)/i.test(userAgent);

            return isIOSWebView || isAndroidWebView;
        })();
        const isIPhone = /iphone/i.test(userAgent);
        if (isWebView) {
            if (window.BRIDGE && typeof window.BRIDGE.closeWebView === "function") {
                window.BRIDGE.closeWebView();
            } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.BRIDGE) {
                window.webkit.messageHandlers.BRIDGE.postMessage('closeWebView');
            } else {

            }
        } else {
            
        }


    }

    const btnStyle = {
        width: "90%",
        backgroundColor: "#40A9FF",
        color: "white",
        border: "none",
        height: "48px"
    }
    return (
        <Container height={"100vh"} backgroundColor={"white"}>
            <VerticalFlex>
                <FlexChild justifyContent={"flex-end"}>
                    
                    <Dummy height={"55px"} />
                    <P size={"7vw"} font={"GmarketSansBold"} color={"black"}>결제완료!</P>
                    <Dummy height={"15px"} />
                    <P color={"black"} size={18} weight={"bold"}>결제가 정상적으로 완료되었습니다.</P>
                </FlexChild>
                <FlexChild>
                    <P>{testState}</P>
                </FlexChild>
                <FlexChild justifyContent={"flex-end"}>
                    {
                        visible &&
                        <CustomButton style={btnStyle} onClick={onClick} text={"돌아가기"} />
                    }

                </FlexChild>
                <FlexChild></FlexChild>

            </VerticalFlex>
        </Container>
    );
}

export default PaymentComplete;